import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Trophy, Crown, Instagram, ArrowRight } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TIER_EMOJI = { bronze: "🥉", silver: "🥈", gold: "🥇", platinum: "💎" };

/**
 * Monthly Creator Spotlight — surfaces the #1 creator on the landing page.
 * Gracefully renders nothing if no spotlight exists yet (new deploy).
 */
export default function CreatorSpotlightCard() {
  const [sp, setSp] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/creators/spotlight`)
      .then((r) => setSp(r.data.spotlight))
      .catch(() => setSp(null));
  }, []);

  if (!sp || !sp.name) return null;

  return (
    <section className="py-10 px-4 bg-gradient-to-br from-[#1E1B4B] via-[#3B0764] to-[#E83E8C] text-white" data-testid="creator-spotlight">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-2 mb-3">
          <Crown size={18} className="text-[#FF9F1C]" />
          <span className="text-[11px] uppercase tracking-[0.25em] font-bold text-[#FF9F1C]">Creator of the month</span>
        </div>

        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 border border-white/20 flex items-center gap-4 flex-wrap">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#FF9F1C] to-[#E83E8C] flex items-center justify-center text-2xl font-black shrink-0">
            {(sp.name || "C").slice(0, 1).toUpperCase()}
          </div>
          <div className="flex-1 min-w-[180px]">
            <h3 className="text-2xl font-black" data-testid="spotlight-name">{sp.name}</h3>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              {sp.tier && (
                <span className="text-[11px] px-2 py-0.5 rounded-full bg-white/20 font-bold">
                  {TIER_EMOJI[sp.tier]} {sp.tier}
                </span>
              )}
              {sp.instagram && (
                <a
                  href={`https://instagram.com/${(sp.instagram || "").replace("@", "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[11px] text-white/80 hover:text-white flex items-center gap-0.5"
                >
                  <Instagram size={11} /> @{(sp.instagram || "").replace("@", "")}
                </a>
              )}
              <span className="text-[11px] text-white/80">· {sp.bookings} bookings this month</span>
            </div>
          </div>
          <Link
            to="/creators/leaderboard"
            className="flex items-center gap-1 px-4 py-2 rounded-full bg-white text-[#E83E8C] text-xs font-bold hover:bg-[#FF9F1C] hover:text-white transition"
            data-testid="spotlight-leaderboard-btn"
          >
            <Trophy size={12} /> See Leaderboard <ArrowRight size={12} />
          </Link>
        </div>

        <p className="text-center text-xs text-white/60 mt-4">
          Want to be next?{" "}
          <Link to="/creators/dashboard" className="underline font-bold text-white" data-testid="spotlight-join-cta">
            Join the Creator Program →
          </Link>
        </p>
      </div>
    </section>
  );
}
